// extracted by mini-css-extract-plugin
export var deliveryRow = "_ps-a";
export var fixedHeight = "_ps-4";
export var freightLogo = "_ps-9";
export var fullWidth = "_ps-3";
export var priceColumn = "_ps-5";
export var radioSelected = "_ps-7";
export var radioUnselected = "_ps-6";
export var selectedOption = "_ps-2";
export var selectedOptionContainer = "_ps-1";
export var selection = "_ps-0";
export var tallSkeletonText = "_ps-8";